import { createContext, ReactNode, useContext } from 'react'
import { FieldValues, useForm, UseFormReturn } from 'react-hook-form'

interface ModalWizzarSideNavContextProps<TDefaultValues> {
  data?: TDefaultValues
}

// Define the context
interface ModalWizzarSideNavContextType<TDefaultValues> {
  data?: TDefaultValues
  useFormWizzard: UseFormReturn<FieldValues>
}

const ModalWizzarSideNavContext = createContext<
  ModalWizzarSideNavContextType<unknown> | undefined
>(undefined)

export const ModalWizardSideNavProvider = <TDefaultValues,>({
  data,
  children,
}: ModalWizzarSideNavContextProps<TDefaultValues> & {
  children: ReactNode
}) => {
  const useFormWizzard = useForm()

  const contextValue: ModalWizzarSideNavContextType<TDefaultValues> = {
    useFormWizzard,
    data: data,
  }

  return (
    <ModalWizzarSideNavContext.Provider value={contextValue}>
      {children}
    </ModalWizzarSideNavContext.Provider>
  )
}

// Custom hook to use the modal wizard side nav context
export const useModalWizardSideNavContext = <TDefaultValues,>() => {
  const context = useContext(ModalWizzarSideNavContext) as
    | ModalWizzarSideNavContextType<TDefaultValues>
    | undefined
  if (context === undefined) {
    throw new Error(
      'useModalWizardSideNavContext must be used within a ModalWizardSideNavProvider'
    )
  }
  return context
}
